import { useUpdateVenue } from '@api';
import { useNotification } from '@common';
import { AxiosError } from 'axios';

const TRANS_KEY_NOTIFICATION = 'NOTIFICATIONS.UPDATE_VENUE_OPERATOR';

type UseUpdateVenueOperatorArgsType = {
  venueId: string;
};

type UseUpdateVenueOperatorReturnType = {
  handleUpdate: (operatorId: string) => void;
  isPending: boolean;
};

export const useUpdateVenueOperator = ({
  venueId,
}: UseUpdateVenueOperatorArgsType): UseUpdateVenueOperatorReturnType => {
  const { showError, showSuccess } = useNotification();
  const { mutateAsync: mutateUpdate, isPending } = useUpdateVenue();

  const onSuccess = (): void => {
    showSuccess({
      title: `${TRANS_KEY_NOTIFICATION}.SUCCESS.TITLE`,
      message: `${TRANS_KEY_NOTIFICATION}.SUCCESS.MESSAGE`,
    });
  };

  const onError = (error: AxiosError): void => {
    showError({
      title: `${TRANS_KEY_NOTIFICATION}.ERROR.TITLE`,
      message: `${TRANS_KEY_NOTIFICATION}.ERROR.MESSAGE`,
      error: error,
    });
  };

  const handleUpdate = (operatorId: string): void => {
    mutateUpdate(
      {
        id: venueId,
        data: { venueOperator: operatorId },
      },
      {
        onSuccess,
        onError,
      }
    );
  };

  return { handleUpdate, isPending };
};
